import { ApolloClient, ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { cache } from './cache'
import { authenticationMiddleware } from '../authentication/authentication'
import { errorLink } from './error-link'

const graphqlEndpoint = `${process.env.REACT_APP_API_HOST ?? ''}/graphql`

export const client = new ApolloClient({
  link: errorLink
    .concat(authenticationMiddleware)
    .concat(
      createUploadLink({ uri: graphqlEndpoint }) as unknown as ApolloLink,
    ),
  cache,
  connectToDevTools: process.env.NODE_ENV === 'development',
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  },
})
